export const vehicleTypes = [
  { value: 'Auto/Jeep/SW', label: 'Auto/Jeep/SW', price: 9750 },
  { value: 'Camioneta Furgon', label: 'Camioneta Furgon', price: 13800 },
  { value: 'Minibus', label: 'Minibus', price: 40500 },
  { value: 'Bus particular', label: 'Bus particular', price: 60000 },
  {
    value: 'Camión y tractor',
    label: 'Camión y tractor',
    price: 40500,
  },
  { value: 'Remolque', label: 'Remolque', price: 7050 },
];

export const vehicleInspectionTypes = [
  { value: 'Minibus', label: 'Minibus', price: 13500 },
  { value: 'Bus particular', label: 'Bus particular', price: 19950 },
];
